export const GET_LIST = 'header/GET_LIST';
export const CITYID = 'header/CITYID';
export const WEATHER = 'header/WEATHER';

